(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('hyperapp')) :
  typeof define === 'function' && define.amd ? define(['exports', 'hyperapp'], factory) :
  (factory((global.hyperappRouter = {}),global.hyperapp));
}(this, (function (exports,hyperapp) { 'use strict';

  function getOrigin(loc) {
    return loc.protocol + "//" + loc.hostname + (loc.port ? ":" + loc.port : "")
  }

  function isExternal(anchorElement) {
    // Location.origin and HTMLAnchorElement.origin are not
    // supported by IE and Safari.
    return getOrigin(location) !== getOrigin(anchorElement)
  }

  function Link(props, children) {
    return function(state, actions) {
      var to = props.to;
      var location = state.location;
      var onclick = props.onclick;
      delete props.to;
      delete props.location;

      props.href = to;
      props.onclick = function(e) {
        if (onclick) {
          onclick(e);
        }
        if (
          e.defaultPrevented ||
          e.button !== 0 ||
          e.altKey ||
          e.metaKey ||
          e.ctrlKey ||
          e.shiftKey ||
          props.target === "_blank" ||
          isExternal(e.currentTarget)
        ) {
        } else {
          e.preventDefault();

          if (to !== location.pathname) {
            history.pushState(location.pathname, "", to);
          }
        }
      };

      return hyperapp.h("a", props, children)
    }
  }

  function createMatch(isExact, path, url, params) {
    return {
      isExact: isExact,
      path: path,
      url: url,
      params: params
    }
  }

  function trimTrailingSlash(url) {
    for (var len = url.length; "/" === url[--len]; );
    return url.slice(0, len + 1)
  }

  function decodeParam(val) {
    try {
      return decodeURIComponent(val)
    } catch (e) {
      return val
    }
  }

  function parseRoute(path, url, options) {
    if (path === url || !path) {
      return createMatch(path === url, path, url)
    }

    var exact = options && options.exact;
    var paths = trimTrailingSlash(path).split("/");
    var urls = trimTrailingSlash(url).split("/");

    if (paths.length > urls.length || (exact && paths.length < urls.length)) {
      return
    }

    for (var i = 0, params = {}, len = paths.length, url = ""; i < len; i++) {
      if (":" === paths[i][0]) {
        params[paths[i].slice(1)] = urls[i] = decodeParam(urls[i]);
      } else if (paths[i] !== urls[i]) {
        return
      }
      url += urls[i] + "/";
    }

    return createMatch(false, path, url.slice(0, -1), params)
  }

  function Route(props) {
    return function(state, actions) {
      var location = state.location;
      var match = parseRoute(props.path, location.pathname, {
        exact: !props.parent
      });

      return (
        match &&
        props.render({
          match: match,
          location: location
        })
      )
    }
  }

  function Switch(props, children) {
    return function(state, actions) {
      var child,
        i = 0;
      while (
        !(child = children[i] && children[i](state, actions)) &&
        i < children.length
      )
        i++;
      return child
    }
  }

  function Redirect(props) {
    return function(state, actions) {
      var location = state.location;
      history.replaceState(props.from || location.pathname, "", props.to);
    }
  }

  function wrapHistory(keys) {
    return keys.reduce(function(next, key) {
      var fn = history[key];

      history[key] = function(data, title, url) {
        fn.call(this, data, title, url);
        dispatchEvent(new CustomEvent("pushstate", { detail: data }));
      };

      return function() {
        history[key] = fn;
        next && next();
      }
    }, null)
  }

  var location$1 = {
    state: {
      pathname: window.location.pathname,
      previous: window.location.pathname
    },
    actions: {
      go: function(pathname) {
        history.pushState(null, "", pathname);
      },
      set: function(data) {
        return data
      }
    },
    subscribe: function(actions) {
      function handleLocationChange(e) {
        actions.set({
          pathname: window.location.pathname,
          previous: e.detail
            ? (window.location.previous = e.detail)
            : window.location.previous
        });
      }

      var unwrap = wrapHistory(["pushState", "replaceState"]);

      addEventListener("pushstate", handleLocationChange);
      addEventListener("popstate", handleLocationChange);

      return function() {
        removeEventListener("pushstate", handleLocationChange);
        removeEventListener("popstate", handleLocationChange);
        unwrap();
      }
    }
  };

  exports.Link = Link;
  exports.Route = Route;
  exports.Switch = Switch;
  exports.Redirect = Redirect;
  exports.location = location$1;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=router.js.map
